<template>
  <div class="business-map-wrapper">
    <div
      class="map"
      ref="map"
    />
    <div class="info-window-wrapper">
      <info-window-content
        :business="business"
        :show-link="false"
        ref="infoWindowContent"
      />
    </div>
  </div>
</template>
<script>
import agencyPin from '../../../../images/agency-pin.png'
import agencyPinPro from '../../../../images/agency-pin-pro.png'
import InfoWindowContent from '../../shared/map/InfoWindowContent'

export default {
  name: 'BusinessDetailMap',
  components: {
    InfoWindowContent,
  },
  props: {
    business: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.$store.dispatch('ui/LOAD_GOOGLE_MAPS_SCRIPT', this.initMap)
  },
  computed: {
    mapCenter() {
      return { lat: this.business.city.latitude, lng: this.business.city.longitude }
    },
  },
  methods: {
    initMap() {
      this.$nextTick(() => {
        this.map = new window.google.maps.Map(this.$refs.map, {
          center: this.mapCenter,
          zoom: 10,
          mapTypeControl: false,
        })

        this.addMarker()
      })
    },
    addMarker() {
      const infoWIndow = new window.google.maps.InfoWindow({
        content: this.$refs.infoWindowContent.$el,
      })
      const pinIcon = this.business.is_pro_plus ? agencyPinPro : agencyPin

      const marker = new window.google.maps.Marker({
        position: this.mapCenter,
        map: this.map,
        icon: pinIcon,
        rentBusinessId: this.business.id,
      })

      marker.addListener('click', () => {
        infoWIndow.open(this.map, marker)
      })
    },
  },
}
</script>
<style lang="scss" scoped>

.map {
  min-height: 380px;
}

.info-window-wrapper > * {
  display: none;
}
</style>
